import React, { Component } from 'react';

import EntityValue from './EntityValue';

import './GlobalEntity.css';

class GlobalEntity extends Component {

  static defaultProps = {
    entityName : "UNDEFINED",
    entityArray : "",
  }

  state = { 
    
  }

  handleEntityClicked = (e) => {
    
  }

  render() {
    const {handleEntityClicked} = this;

    const {props} = this;
    const {entityName} = props;
    const {entityArray} = props;
    

    if (!entityArray) {
      return;
    }

    const splitedEntityArray = entityArray.split('||');
    
    
    const renderedEntityArray = splitedEntityArray.map( entity => {
      
      return (
        <EntityValue 
          value ={entity} />
      );
    });

    return (
      <div className="global-entity row"
        onClick={handleEntityClicked}>
        <div className="title">
          <h2 className="value"> {entityName} </h2>
        </div>
        <div className="content">
          {renderedEntityArray}
        </div>
      </div>
    );
  }
}

export default GlobalEntity;